import { complement, curry, filter, pickBy } from 'ramda'
import { isArrayLike } from './isArrayLike'

export const removeWhen = curry((cond, value) =>
  isArrayLike(value)
    ? filter(complement(cond))
    : pickBy(complement(cond), value),
)
